import { ROUTE_BASE_NAME } from '~/constants'

import type { UseAuthentication } from '~/types/rental-api-aliases'
import type { Nullable } from '~/types'

/**
 * This middleware gates if a user's profile has been completed or not. This is
 * used primarily in the RTB flow, before people enter it.
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const { data, status } = useAuth()

  if (status.value !== 'authenticated') {
    return
  }

  const profileState = (data.value as Nullable<UseAuthentication>)?.ProfileState

  if (profileState !== 'Incomplete') {
    return
  }

  // Store the intent of the navigated route.
  const intentCookie = useIntentCookie()
  const getRouteBaseName = useRouteBaseName()
  const { checkRouteNameStartsWith } = useBaseName()
  const name = getRouteBaseName(to)?.toString() ?? ''

  if (checkRouteNameStartsWith(name, ROUTE_BASE_NAME.request_to_book)) {
    intentCookie.value = 'BookingIntent'
  }

  usePendingRequestToBookUrlCookie().value = to.fullPath

  const cameFromSomewhereElse = from.matched.length > 0 && from.fullPath !== to.fullPath
  const localePath = useLocalePath()

  return navigateTo(cameFromSomewhereElse ? from.fullPath : localePath('index'))
})
